import { useEffect } from 'react';

export function HubspotScript() {
    useEffect(() => {
        if (document.getElementById('hs-script-loader')) {
            return;
        }

        const script = document.createElement('script');
        script.id = 'hs-script-loader';
        script.async = true;
        script.defer = true;
        script.src = 'https://js-eu1.hs-scripts.com/25702094.js';

        document.body.appendChild(script);
    }, []);

    return null;
}
